if(!customElements.get('ia-easy-color'))customElements.define('ia-easy-color',class extends HTMLElement{
connectedCallback(){
this.abort=new AbortController();const signal=this.abort.signal;
this.form=document.getElementById(this.dataset.form);this.product=this.closest('product-info');
this.add=this.querySelector('[data-easy-add]');
this.querySelectorAll('[data-easy-step]').forEach(b=>{
b.addEventListener('click',()=>{
const inputs=Array.from(this.querySelectorAll('.ia-kgel-grid input[type=radio]'));
const index=inputs.findIndex(x=>x.checked);
const target=inputs[index+Number(b.dataset.easyStep)];
if(target){this.add.disabled=true;target.click();this.refreshNavigation();}
},{signal});
});
this.refreshNavigation();
this.product?.addEventListener('change',e=>{
if(e.target.matches('.ia-kgel-cell input')){this.pending=true;this.add.disabled=true;}
},{signal});
this.add.addEventListener('click',()=>{const native=this.form?.querySelector('[name=add]');if(!this.pending&&native&&!native.disabled&&String(this.form.querySelector('[name=id]')?.value)===this.dataset.variant)this.form.requestSubmit(native);},{signal});
const sync=()=>{const native=this.form?.querySelector('[name=add]');this.add.disabled=Boolean(this.pending||!native||native.disabled||String(this.form.querySelector('[name=id]')?.value)!==this.dataset.variant);};
document.addEventListener('variant:changed',()=>{this.pending=false;sync();},{signal});
this.observer=new MutationObserver(sync);if(this.form)this.observer.observe(this.form,{subtree:true,attributes:true,childList:true,attributeFilter:['disabled','value']});sync();
}
refreshNavigation(){
const inputs=Array.from(this.querySelectorAll('.ia-kgel-grid input[type=radio]'));
const index=inputs.findIndex(x=>x.checked);
this.querySelectorAll('[data-easy-step]').forEach(b=>{const next=index+Number(b.dataset.easyStep);b.disabled=next<0||next>=inputs.length;});
}
disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
});
